import * as React from "react";
import * as Helpers from "../helpers";
import { StepWizardChildProps } from "react-step-wizard";
import InputText from "../Components/InputText";
import PageNavigation from "../Components/PageNavigation";
import InputBoolean from "../Components/InputBoolean";
import Steps from "./steps";

export type HomeDetailsFields = {
    home_bedrooms: string;
    home_bathrooms: string;
    home_pets: string;
    home_pets_details: string;
}

export class HomeDetails extends React.Component<PageProps<HomeDetailsFields> & Partial<StepWizardChildProps>, PageState> {
    constructor(props: PageProps<HomeDetailsFields>) {
        super(props);

        this.state = {
            validation_triggered: false
        };
    }

    triggerValidation()
    {
        const page_fields = ["home_bedrooms", "home_bathrooms", "home_pets"];

        if (this.props.form_values.home_pets === "true") {
            page_fields.push("home_pets_details");
        }

        return Helpers.TriggerValidation(this, page_fields, this.props.required, this.props.form_values);
    }

    goBack() {
        if (this.props.previousStep) {
            this.props.previousStep();
        }
    }

    submit() {
        const validation_result = this.triggerValidation();
        if (!validation_result) {
            return;
        }

        if (this.props.nextStep) {
            this.props.nextStep();
        }
    }

    render() {
        let scrolled = false;
        let getScrolled = () => scrolled;
        let setScrolled = () => { scrolled = true; };

        return <div>
            <InputText
                label="Number of Bedrooms"
                type="range"
                min={1}
                max={10}
                step={1}
                valueSuffix="bedrooms"
                name="home_bedrooms"
                value={this.props.form_values.home_bedrooms}
                required={this.props.required.home_bedrooms}
                validation_triggered={this.state.validation_triggered}
                validation_get_scrolled={getScrolled}
                validation_set_scrolled={setScrolled}
                update_value={this.props.update_value}
            />

            <InputText
                label="Number of Bathrooms"
                type="range"
                min={1}
                max={10}
                step={1}
                valueSuffix="bathrooms"
                name="home_bathrooms"
                value={this.props.form_values.home_bathrooms}
                required={this.props.required.home_bathrooms}
                validation_triggered={this.state.validation_triggered}
                validation_get_scrolled={getScrolled}
                validation_set_scrolled={setScrolled}
                update_value={this.props.update_value}
            />


            <InputBoolean
                label="Do you have any pets?"
                name="home_pets"
                value={this.props.form_values.home_pets}
                required={this.props.required.home_pets}
                validation_message="Please select whether you have any pets."
                validation_triggered={this.state.validation_triggered}
                validation_get_scrolled={getScrolled}
                validation_set_scrolled={setScrolled}
                update_value={this.props.update_value}
            />

            {
                this.props.form_values.home_pets === "true" ?
                <InputText
                    label="Please state what pets you have"
                    type="textarea"
                    rows={2}
                    name="home_pets_details"
                    value={this.props.form_values.home_pets_details}
                    required={this.props.required.home_pets_details}
                    validation_message="Please state what pets you have."
                    validation_triggered={this.state.validation_triggered}
                    validation_get_scrolled={getScrolled}
                    validation_set_scrolled={setScrolled}
                    update_value={this.props.update_value}
                />
                : null
            }

            <div className="row">
                <div className="col-md-6">
                    <Steps totalSteps={this.props.totalSteps!} currentStep={this.props.currentStep!} />
                </div>
                <div className="col-md-6">
                    <PageNavigation allowPrevious={true} allowNext={true} useSubmitForNext={false} onNext={() => this.submit()} onPrevious={() => this.goBack()} />
                </div>
            </div>
        </div>;
    }
}